import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@mui/material";
import { poPrimaryBtnSx, poSecondaryBtnSx } from "./poUi";

/**
 * In-app confirm dialog (replaces window.confirm for PO flows).
 * @param {{ open: boolean, title?: string, message: string, confirmLabel?: string, cancelLabel?: string, loading?: boolean, onConfirm: () => void, onCancel: () => void }} props
 */
const PoConfirmDialog = ({
	open,
	title = "Confirm",
	message,
	confirmLabel = "Confirm",
	cancelLabel = "Cancel",
	loading = false,
	onConfirm,
	onCancel,
}) => (
	<Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
		<DialogTitle sx={{ fontSize: 17, fontWeight: 700 }}>{title}</DialogTitle>
		<DialogContent>
			<Typography sx={{ fontSize: 14, lineHeight: 1.5 }}>{message}</Typography>
		</DialogContent>
		<DialogActions sx={{ px: 2.5, pb: 2, gap: 1 }}>
			<Button variant="outlined" onClick={onCancel} disabled={loading} sx={poSecondaryBtnSx}>
				{cancelLabel}
			</Button>
			<Button
				variant="contained"
				onClick={onConfirm}
				disabled={loading}
				startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
				sx={poPrimaryBtnSx}
				autoFocus>
				{confirmLabel}
			</Button>
		</DialogActions>
	</Dialog>
);

export default PoConfirmDialog;
